import(/* webpackMode: "eager" */ "/codebuild/output/src42096774/src/web-app/packages/webapp/app/error.tsx");
